export function formatPrice(
    e,
    row,
    eventType,
    nameModel,
    len = 8,
    len2 = 2,
    isNegative
) {
    console.log("nameModel", nameModel, row[nameModel]);
    if (isNegative) {
        row[nameModel] = row[nameModel].replace(/[^-0-9.]/g, ""); //清除“数字”和“.”和“-”以外的字符
    } else {
        if (len2 > 0) {
            row[nameModel] = row[nameModel].replace(/[^0-9.]/g, ""); //清除“数字”和“.”以外的字符
        } else {
            row[nameModel] = row[nameModel].replace(/[^0-9]/g, ""); //清除“数字”和“.”以外的字符
        }
    }
    row[nameModel] = row[nameModel].replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
    row[nameModel] = row[nameModel]
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");

    let pattern = eval(`/^(-)*(\\d+)\\.(\\d{0,${len2}}).*$/`);
    // row[nameModel] = row[nameModel].replace(/^(-)*(\d+)\.(\d{0,4}).*$/, '$1$2.$3') // 只能输入六位小数
    row[nameModel] = row[nameModel].replace(pattern, "$1$2.$3"); // 只能输入六位小数

    if (row[nameModel].indexOf(".") <= 0 && row[nameModel] != "") {
        if (isNegative) {
            if (/^-*-$/.test(row[nameModel])) {
                // 处理连续两次输入负号
                row[nameModel] = "-";
            }
            //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
            if (row[nameModel] != "." && row[nameModel] != "-") {
                // 可以输入负数
                if (row[nameModel] != "-0") {
                    // 单独处理-0的情况
                    row[nameModel] = parseFloat(row[nameModel]);
                }
            }
        } else {
            //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
            if (row[nameModel] != ".") {
                // 可以输入负数
                row[nameModel] = parseFloat(row[nameModel]);
            }
        }
    }
    if (isNegative) {
        if (/^-\.\d{1}/.test(row[nameModel])) {
            // 处理-.2的情况
            // 判断是否有输入小数点
            row[nameModel] = parseFloat(row[nameModel]);
        }
    }
    let _value = row[nameModel] + "";
    if (/\./.test(_value)) {
        const temp = _value;
        const integer = temp.split(".")[0];
        const decimal = temp.split(".")[1];
        _value = integer.slice(0, len) + "." + decimal;
    } else {
        if (_value.length > len) {
            console.log(`超过了${len}位`);
            _value = _value.slice(0, len);
        }
    }
    row[nameModel] = _value;
    return _value;
}

// 处理金额小数点后保留几位
export function formatNumber(
    value,
    num,
    thousands = false,
    prefix = "",
    suffix = ""
) {
    if ([null, undefined, NaN, ""].includes(value)) return "";
    const val = new BigNumber(value);
    if (num) {
        let func = null;
        if (thousands) {
            func = "toFormat";
        } else {
            func = "toFixed";
        }
        let t = val[func](num);
        t = prefix + t + suffix;
        return t;
    } else {
        return val.toJSON();
    }
}